// Mobile quote sheet — Stream 3 PR-3.
//
// Bottom-sheet wrapper around QuoteRequestPanel for custom-quote
// (pricingMode === 'quote') listings on mobile. Opens when the
// MobileBookingBar's CTA is tapped; closes via the modal's standard
// dismiss affordances (close button, Esc, backdrop tap).
//
// Reuses the existing Modal infrastructure with the new
// position="bottom" prop (Q6 lock — extend Modal, don't fork). On
// desktop the modal collapses to centered automatically; the page
// only ever renders this on mobile (CSS hides it above 768px) so
// that's a theoretical concern, but the prop is correct in either
// case.

import React from 'react';

import { Modal } from '../../../components';

import QuoteRequestPanel from '../QuoteRequestPanel/QuoteRequestPanel';
import css from './MobileQuoteSheet.module.css';

const MobileQuoteSheet = props => {
  const {
    id = 'MobileQuoteSheet',
    isOpen,
    onClose,
    onManageDisableScrolling,
    listing,
    authorDisplayName,
    isOwnListing,
    inProgress,
    error,
    onSubmitQuoteRequest,
  } = props;

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      position="bottom"
      contentClassName={css.sheetContent}
    >
      <QuoteRequestPanel
        className={css.embeddedPanel}
        listing={listing}
        authorDisplayName={authorDisplayName}
        isOwnListing={isOwnListing}
        inProgress={inProgress}
        error={error}
        onSubmitQuoteRequest={values => {
          if (onSubmitQuoteRequest) onSubmitQuoteRequest(values);
        }}
      />
    </Modal>
  );
};

export default MobileQuoteSheet;
